import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import HomePage from "./pages/HomePage";
import ServiziPage from "./pages/ServiziPage";
import ChiSiamoPage from "./pages/ChiSiamoPage";
import GalleryPage from "./pages/GalleryPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContattiPage from "./pages/ContattiPage";
import NormativePage from "./pages/NormativePage";
import PrivacyPage from "./pages/PrivacyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import "./App.css";

function App() {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('revo_cookie_consent');
    if (!consent) {
      setShowCookieBanner(true);
    }
  }, []);

  const handleCookieAccept = () => {
    localStorage.setItem('revo_cookie_consent', 'accepted');
    setShowCookieBanner(false);
  };

  const handleCookieReject = () => {
    localStorage.setItem('revo_cookie_consent', 'rejected');
    setShowCookieBanner(false);
  };

  return (
    <div className="min-h-screen bg-revo-bg">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/chi-siamo" element={<ChiSiamoPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="/normative" element={<NormativePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          </Routes>
        </main>
        <Footer />
        {showCookieBanner && (
          <CookieBanner 
            onAccept={handleCookieAccept} 
            onReject={handleCookieReject} 
          />
        )}
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#0A0A0A',
              border: '1px solid #27272A',
              color: '#EDEDED',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
